import {
  Module,
  VuexModule,
  Action,
  getModule,
  Mutation
} from 'vuex-module-decorators'
import Vue from 'vue'
import axios from 'axios'

import store from '@/store'
import eventModule from '@/store/event'
import authModule from '@/store/auth'
import { User } from '@/types/User'
import { initialCookie } from '@/utils/storage-init'

const name = 'user'

@Module({
  namespaced: true,
  dynamic: true,
  name,
  store,
  preserveState: Boolean(initialCookie[name])
})
class UserModule extends VuexModule {
  private currentLocation: { lat: number; lng: number } = { lat: 0, lng: 0 }

  get location() {
    return this.currentLocation
  }

  get hasCategories(): boolean {
    return authModule.user!.categories.length >= 6
  }

  @Mutation
  private setCurrentLocation(payload: { lat: number; lng: number }) {
    Vue.set(this, 'currentLocation', payload)
  }

  @Action({ rawError: true })
  async update(payload: Partial<User>) {
    try {
      const { data } = await axios.put('/users', payload)
      authModule.setUser(data.user)
      eventModule.newMessage('Profil wurde erfolgreich aktualisiert')
    } catch (error) {
      eventModule.newError('Profil konnte nicht aktualisiert werden')
    }
  }

  @Action({ rawError: true })
  async updateWebPushToken(webPushToken: string) {
    try {
      const { data } = await axios.put('/users', { webPushToken })
      authModule.setUser(data.user)
    } catch (error) {}
  }

  @Action({ rawError: true })
  async updatePassword(payload: { oldPassword: string; newPassword: string }) {
    try {
      const { data } = await axios.put('/users/changePassword', payload)
      authModule.setTokens(data)
      eventModule.newMessage('Passwort wurde erfolgreich aktualisiert')
    } catch (error) {
      eventModule.newError('Password konnte nicht aktualisiert werden')
    }
  }

  @Action({ rawError: true })
  async delete() {
    try {
      await axios.delete(`/users/${authModule.user!.id}`)
      authModule.logout()
      return true
    } catch (error) {
      eventModule.newError('Profil konnte nicht gelöscht werden')
      return false
    }
  }

  @Action({ rawError: true })
  async confirmAccount(payload: { token: string }) {
    try {
      await axios.post('/users/confirm', payload)
      eventModule.newMessage('Dein Account wurde erfolgreich aktiviert!')
      return true
    } catch (error) {
      eventModule.newError(
        'Dein Account konnte nicht aktiviert werden. Versuche es bitte erneut'
      )
      return false
    }
  }

  @Action({ rawError: true })
  async resetPassword(email: string) {
    try {
      await axios.post('/users/resetPassword', { email })
      eventModule.newMessage('Anfrage wurde verschickt')
    } catch (error) {
      eventModule.newError(
        'Ups! Da ist etwas schief gelaufen. Veruche es bitte erneut'
      )
    }
  }

  @Action({ rawError: true })
  async setNewPassword(payload: { token: string; newPassword: string }) {
    try {
      await axios.post('/users/submitResetPassword', payload)
      eventModule.newMessage(
        'Dein Password wurde erfolgreich wiederhergestellt!'
      )
    } catch (error) {
      eventModule.newError(
        'Ups! Da ist etwas schief gelaufen. Veruche es bitte erneut'
      )
    }
  }

  @Action({ rawError: true })
  async invite(email: string) {
    try {
      await axios.post('/sendInvitation', { email })
      eventModule.newMessage('Deine Einladung wurde verschickt')
    } catch (error) {
      eventModule.newError('Einladung konnte nicht verschickt werden')
    }
  }

  @Action({ rawError: true })
  setLocation(payload: { lat: number; lng: number }) {
    this.context.commit('setCurrentLocation', payload)
  }
}

export default getModule(UserModule)
